import "./DealSummaryDetailsCard.css";

import { ReactNode } from "react";

import { ReadonlyText } from "../../../../widget";

export interface DealSummaryDetailItem {
  label: string;
  value: ReactNode;
}

interface DealSummaryDetailsCardProps {
  title: string;
  leftItems: DealSummaryDetailItem[];
  rightItems: DealSummaryDetailItem[];
  action?: ReactNode;
}

export const DealSummaryDetailsCard = ({
  title,
  leftItems,
  rightItems,
  action,
}: DealSummaryDetailsCardProps): JSX.Element => {
  return (
    <div className="DealSummaryDetailsCard">
      <div className="DealSummaryDetailsCardHeader">
        <h2>{title}</h2>
        {action ? <div className="DealSummaryDetailsCardAction">{action}</div> : null}
      </div>
      <div className="DealSummaryDetailsCardContent">
        <div className="DealSummaryDetailsCardColumn">
          {leftItems.map((item) => (
            <div className="DealSummaryDetailItem" key={item.label}>
              <ReadonlyText label={item.label} value={item.value as string} textClass="body2" />
            </div>
          ))}
        </div>
        <div className="DealSummaryDetailsCardColumn">
          {rightItems.map((item) => (
            <div className="DealSummaryDetailItem" key={item.label}>
              <ReadonlyText label={item.label} value={item.value as string} textClass="body2" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
